module.exports = __webpack_public_path__ + "static/media/spearguns 073.cd38eafb.jpg";